import dayjs from "dayjs"

import type { ProductCostBreakdownRow } from "./types"

import type { ProductWarehouseItem, PurchasingCostListEntry } from "@/graphql/codegen/graphql"
import { getGoodsReceiptPurchaseOrderLines } from "@/screens/WarehouseReceiving/utils"

export const isCurrentCost = (cost: PurchasingCostListEntry, today: dayjs.Dayjs): boolean => {
  const effectiveDate = dayjs(cost.effectiveDate)
  if (effectiveDate.isAfter(today, "day")) return false
  if (!cost.expirationDate) return true
  return !dayjs(cost.expirationDate).isBefore(today, "day")
}

export const isPastCost = (cost: PurchasingCostListEntry, today: dayjs.Dayjs): boolean =>
  !!cost.expirationDate && dayjs(cost.expirationDate).isBefore(today, "day")

export const transformProductWarehouseItemsToRows = (
  items: ProductWarehouseItem[],
  productId: number
): ProductCostBreakdownRow[] => {
  return items.flatMap((item): ProductCostBreakdownRow[] => {
    const { goodsReceipt, ...costBreakdown } = item

    if (!goodsReceipt) {
      return [{ costBreakdown, goodsReceipt: null, purchaseOrderLine: null }]
    }

    const purchaseOrderLines = getGoodsReceiptPurchaseOrderLines(goodsReceipt).filter(
      (orderLine) => orderLine.product?.productId === productId
    )

    return purchaseOrderLines.map((purchaseOrderLine) => ({ costBreakdown, goodsReceipt, purchaseOrderLine }))
  })
}
